import api from "./auth";

export const getAdministrators = async () => (await api.get("/administrators/")).data;
export const inviteAdministrator = async (payload) => (await api.post("/administrators/invitations", payload)).data;
export const updateAdministratorAccess = async (id, payload) => (await api.patch(`/administrators/${id}/access`, payload)).data;
export const revokeInvitation = async (id) => (await api.delete(`/administrators/invitations/${id}`)).data;
export const inspectInvitation = async (token) => (await api.post("/auth/admin-invitations/inspect", {token})).data;
export const acceptInvitation = async (payload) => (await api.post("/auth/admin-invitations/accept", payload)).data;
